import React, { useState, useEffect } from "react";
import MyVerticallyFileModal from "../imgUpload/fileModal";
import { getAllFiles, getAppParams, deleteFile } from "../../api/api";
import Button from "react-bootstrap/Button";
import InfiniteScroll from "react-infinite-scroll-component";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Listloader from "../loader/content";
import Loader from "../loader/loader";
import { UserLang } from "../../store/userStore";

const FilesTable = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [allImage, setallImage] = useState([]);
  const [imageNum, setImageNum] = useState(0);
  const [hasMore, sethasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const lan = UserLang.useState((s) => s.lan);

  useEffect(() => {
    const getImage = async () => {
      try {
        const appl = await getAllFiles(10, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.filekey,
          label: getAppParams() + item.filekey,
          key: item.filekey,
          name: item.fileName,
          id: item._id,
        }));
        const imageCount = appl.data.count;

        setallImage(opt);
        setImageNum(imageCount);
        if (imageCount < 10) {
          sethasMore(false);
        }
        setLoading(false);
      } catch (error) {}
    };
    getImage();
  }, []);

  const handleDelete = async (event, id, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(allImage);
    items.splice(removeId, 1);
    setallImage(items);
    if (id !== undefined && id !== "") {
      try {
        /* eslint-disable no-unused-vars */
        const result = await deleteFile(id);
        /* eslint-disable no-unused-vars */
        toastr.success("Successfully Saved", "Success");
      } catch (error) {
        toastr.error("Error in deleting the Image", "Error");
      }
    } else {
      toastr.error("Delete Id is Missing", "Error");
    }
  };
  const fetchData = async () => {
    const length = allImage.length;
    try {
      const appl = await getAllFiles(length + 10, length);
      const images = appl.data.images;
      const imageCount = appl.data.count;
      const opt = images.map((item) => ({
        value: item.filekey,
        label: getAppParams() + item.filekey,
        key: item.filekey,
        name: item.fileName,
        id: item._id,
      }));
      const newArray = [...allImage, ...opt];

      setallImage(newArray);
      setImageNum(imageCount);
      if (imageNum === allImage.length) {
        sethasMore(false);
      }
    } catch (error) {}
  };
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Files
                  </h3>

                  <Button
                    variant="primary"
                    onClick={() => setModalShow(true)}
                    style={
                      lan === "rtl"
                        ? {
                            width: "100px",
                            marginTop: "8px",
                            height: "40px",
                            float: "left",
                          }
                        : {
                            width: "100px",
                            marginTop: "8px",
                            height: "40px",
                            float: "right",
                          }
                    }
                  >
                    New Image
                  </Button>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <InfiniteScroll
                              dataLength={allImage.length}
                              hasMore={hasMore}
                              loader={<Listloader></Listloader>}
                              next={fetchData}
                            >
                              <table
                                id="appadmin"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      {" "}
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Files
                                      </label>
                                    </th>

                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Delete
                                      </label>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {allImage.map((image, index) => (
                                    <tr role="row" key={index} className="even">
                                      <td
                                        className="dtr-control sorting_1"
                                        tabIndex={0}
                                      >
                                        <span
                                          className={
                                            lan === "rtl"
                                              ? "float-right text-muted"
                                              : "float-left text-muted"
                                          }
                                        >
                                          {image.name}
                                        </span>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className={
                                            lan === "rtl"
                                              ? "float-right btn btn-light"
                                              : "float-left btn btn-light"
                                          }
                                          onClick={(event) =>
                                            handleDelete(event, image.id, index)
                                          }
                                        >
                                          <i className="fa fa-trash"></i> Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </InfiniteScroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <MyVerticallyFileModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          allimage={allImage}
        />
      </section>
    );
  }
};

export default FilesTable;
